<template lang="html">
  <div class="agent-detail-bethistory--inner">
<!--     <div class="window-details-toolbar">
      <div class="window-details-toolbar__items">
        <select-list
          class="toolbar-nav"
          :title="$route.params.subtype"
          v-model="selectedList"
        >
          <select-option
            value="all"
            name="all"
          >
              <span>all</span>
          </select-option>

          <select-option
            value="cash in"
            name="cash in"
          >
              <span>cash in</span>
          </select-option>

          <select-option
            value="cash out"
            name="cash out"
          >
              <span>cash out</span>
          </select-option>
        </select-list>

        <search
          class="search-bar-wrap"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>

        <button class="btn--create"
        >
          <i class="ico--create"></i>
        </button>

      </div>
    </div> -->

    <check-data-list
      label="loading"
      v-if="isDataLoading || isEmpty"
      :isLoading="isDataLoading"
      :isEmpty="isEmpty"
    >
    </check-data-list>

    <div
      class="bet-history--inner"
      :class="{'data-loading': showDataLoading }"
      v-else
    >
      <div class="betslip__items">
        <betslip-card
          v-for="(slip, index) in betHistory"
          :key="index"
          :logs="slip"
          v-if="!isDataLoading"
          @update="update($event)"
        >
          <bets-card
            v-for="(bets, idx) in slip.userBets"
            :key="idx"
            :logs="bets"
            v-if="slip.userBets.length > 0"
          >
          </bets-card>
        </betslip-card>
      </div>
      <pagination
        :total="count"
        v-model="params.page"
        :rows="params.rows"
        @page="trigger"
      >
      </pagination>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
//= mixins
import { getListStatus } from '@/assets/js/mixins/common/GetListStatus'

//= components
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import BetslipCard from '@/components/common/betslip/BetslipCard'
import BetsCard from '@/components/common/betslip/BetsCard'
import CheckDataList from '@/components/base/CheckDataList'
import Pagination from '@/components/base/Pagination'

export default {
  name: 'agent-detail-bethistory',

  components: {
    Modal,
    Search,
    BetslipCard,
    BetsCard,
    CheckDataList,
    Pagination
  },

  mixins: [
    getListStatus
  ],

  computed: {
    ...mapState('bet-history',
      ['betHistory', 'count'])
  },

  async created () {
    this.params = this.generate(this.params)
    this.search()
  },

  data () {
    let params = Object.assign(
      {
        rows: 10,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,

      isDataLoading: true,
      showDataLoading: false,
      isEmpty: false,

      selectedList: 'cash in',
      filterBy: [
        {
          value: 'amount',
          display: 'amount'
        },

        {
          value: 'request date',
          display: 'request date'
        },

        {
          value: 'confirm date',
          display: 'confirm date'
        },

        {
          value: 'user ip',
          display: 'user ip'
        },

        {
          value: 'from',
          display: 'from'
        }
      ],

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false
    }
  },

  watch: {
    '$route' ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    }
  },

  methods: {
    ...mapActions('bet-history', ['getByAgent']),

    async search (q) {
      console.log(this.$route.params.id, this.params)
      this.params = q || this.params
      this.status = this.$route.params.status

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getByAgent({ id: this.$route.params.id, params: this.params })

      this.isDataLoading = false
      this.showDataLoading = false

      if (!this.betHistory.length) {
        this.isEmpty = true
      }
    },
    trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    },
    clear () {}
  }
}
</script>
